// Expand menu
function expand_menu ( toggle_button, wrapper_element ) {
    const togl = document.getElementById( toggle_button );
    const wrap = document.getElementById( wrapper_element )    
    if( togl && wrap ){
        togl.addEventListener( 'click', function() {
            wrap.classList.toggle( 'open' )
        })
    }
}
export default expand_menu;

// If we have a click menu, javascript will go here
//const show_dropdowns = ( dropdown_togglers ) => {
//    const togglers = document.querySelectorAll( '.' + dropdown_togglers )
//    if( togglers ){
//        //togglers.forEach
//    }
//}

//export default show_dropdowns;